import { render } from "./WaivedBills.vue?vue&type=template&id=881b0460&scoped=true"
import script from "./WaivedBills.vue?vue&type=script&lang=js"
export * from "./WaivedBills.vue?vue&type=script&lang=js"

import "./WaivedBills.vue?vue&type=style&index=0&id=881b0460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881b0460"]])

export default __exports__